import { useQuery } from '@apollo/client';
import { GET_ALL_DISTRITOS, GET_ALL_REDES, GET_ALL_EQUIPAMENTOS, KEY } from '../../Graphql/QUERIES';
import TopBar from '../../components/TopBar';
import { useStyles } from './styles';
import PageContainer from '../../components/PageContainer';
import { Button, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import { useTheme } from '../../hooks/useTheme';
import { useEffect } from 'react';
import BottomBar from '../../components/BottomBar';
import waveBottomImg from '../../assets/wave2.png';

function Search() {
  const classes = useStyles();
  const { changeTheme } = useTheme();
  const { loading: loadingDist, error: errorDist, data: dataDist } = useQuery(GET_ALL_DISTRITOS, {
    variables: { token: KEY }
  });
  const { loading: loadingRedes, error: errorRedes , data: dataRedes } = useQuery(GET_ALL_REDES, {
    variables: { token: KEY }
  });
  const { loading: loadingEqp, error: errorEqp , data: dataEqp } = useQuery(GET_ALL_EQUIPAMENTOS, {
    variables: { token: KEY }
  });
  useEffect(() => {
    changeTheme();
  }, [])

  if(loadingDist || loadingRedes || loadingEqp ) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Carregando...
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Carregando...
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  );
  
  if (errorDist || errorRedes || errorEqp ) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Erro
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Ops! Parece que ocorreu um erro.
            Tente novamente mais tarde.
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  )
  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Pesquisar
        </Typography>
      </TopBar>
      <PageContainer>
        <form className={classes.wrapper} action="/result" method="get">

          <div className={classes.section}>
            <Typography>
              Palavras-chave
            </Typography>
            <Paper elevation={2}>
              <TextField 
                className={classes.input} 
                name="search" 
                variant="outlined"
              />           
            </Paper>
          </div>
          
          <div className={classes.section}>
            <Typography>
              Rede
            </Typography>
            <Paper elevation={2}>
              <TextField 
                className={classes.input} 
                select 
                variant="outlined" 
                name="r" 
                defaultValue="-1"
              >   
                <MenuItem value="-1">
                  Todas
                </MenuItem>
                {dataRedes.TipoRedeAll.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nome}
                  </MenuItem>
                ))}
              </TextField>        
            </Paper>
          </div>    
          
          <div className={classes.section}>
            <Typography>
              Região
            </Typography>
            <Paper elevation={2}>
              <TextField 
                className={classes.input} 
                select 
                variant="outlined" 
                name="d" 
                defaultValue="-1"
              >   
                <MenuItem value="-1">
                  Todas
                </MenuItem>
                {dataDist.DistritoAll.map((option) => (
                  <MenuItem key={option.codigo} value={option.codigo}>
                    {option.nome}
                  </MenuItem>
                ))}
              </TextField>        
            </Paper>
          </div>
          
          <div className={classes.section}>
            <Typography>
              Tipo de Equipamento
            </Typography>
            <Paper elevation={2}>
              <TextField 
                className={classes.input} 
                select 
                variant="outlined" 
                name="e" 
                defaultValue="-1"
              >   
                <MenuItem value="-1">
                  Todas
                </MenuItem>
                {dataEqp.TipoEquipamentoAll.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nome}
                  </MenuItem>
                ))}
              </TextField>        
            </Paper>
          </div>
          
          <Button className={classes.button} type="submit" variant="contained" color="primary">
            Buscar
          </Button>

        </form>
      </PageContainer>
      <div className={classes.waveBottom}>
        <img src={waveBottomImg} alt="onda"/>
      </div>
      <BottomBar/>
    </>
  );
}

export default Search;
